/* Deobfuscated build — © 2025 Jhango. Decrypted from the shipped AES payload. */
;(function(){
document.addEventListener('DOMContentLoaded', function() {
  if (!document.getElementById('theme-overlay')) {
    const overlay = document.createElement('div');
    overlay.id = 'theme-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.background = 'rgba(0, 0, 0, 0.8)';
    overlay.style.color = 'white';
    overlay.style.display = 'flex'; // Shown initially
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.fontSize = '24px';
    overlay.style.zIndex = '9999';
    overlay.style.textAlign = 'center';
    overlay.innerText = 'Enter a valid license to access this theme.';
    document.body.appendChild(overlay);
  }
  const storeUrl = window.location.hostname;
  if (validateLicense(storeUrl)) {
    document.getElementById('theme-overlay').style.display = 'none'; // Hide overlay
  } else {
    document.getElementById('theme-overlay').style.display = 'flex'; // Show overlay
  }

});
function validateLicense(url) {
  const validStoreUrls = [
    "pumpclub.in",
    "www.pumpclub.in",
    "s3mc2f-wt.myshopify.com"
  ];
  return validStoreUrls.includes(url) || url.endsWith(".shopifypreview.com") || url.endsWith(".pumpclub.in") || url.includes("s3mc2f-wt.") || url.includes("localhost") || url.includes("127.0.0.1");
}
  console.log("");  // Add anything inside "" to see whether this file loads
})();
